import {
  Box,
  Button,
  Flex,
  FormControl,
  InputGroup,
  Text,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { CommonAPI } from "../../Apis/commonApi";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { DatePicker, Modal } from "antd";
import dayjs from "dayjs";
import { disabledDate } from "../../Utils/Validator";
import { MdClose } from "react-icons/md";
import ConfirmationModal from "./ConfirmationModal";
import moment from "moment-timezone";

type Props = {
  handleCloseModal: () => void;
  responderId?: string;
  company?: string;
  buyerCompanyName?: string;
  designation?: string;
  eventId?: string;
  meetRequesterPhone?: string;
  context?: "RFX" | "Inquiry"; // Claude: N4 — meeting context 26-02-2026
};

const CreateMeetModal = (props: Props) => {
  const [date, setDate] = useState("");
  const [time, setTime] = useState<any>("");
  const detectedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const [meetConfirm, setMeetConfirm] = useState(false);
  const handleOpenMeetConfirmModal = () => setMeetConfirm(true);
  const handleCloseMeetConfirmModal = () => {
    setMeetConfirm(false);
  };

  const { success, error } = useToastWrapper();

  const clearData = () => {
    setDate("");
    setTime("");
  };

  const [meetTimeConfirm, setMeetTimeConfirm] = useState(false);
  const handleOpenMeetTimeConfirmModal = () => setMeetTimeConfirm(true);
  const handleCloseMeetTimeConfirmModal = () => setMeetTimeConfirm(false);

  const [noDateConfirm, setNoDateConfirm] = useState(false);
  const handleOpenNoDateConfirmModal = () => setNoDateConfirm(true);
  const handleCloseNoDateConfirmModal = () => setNoDateConfirm(false);

  const handleConfirmCancelModal = async () => {
    //Create meeting date in local time zone
    console.log("CreateMeetModal - detectedTimezone:",detectedTimezone);

    // Claude: only include eventId if present — direct meetings have no event context 19-02-2026
    // Claude: N4 — include context if provided 26-02-2026
    let data: any = {
      ...(props.eventId ? { eventId: props.eventId } : {}),
      ...(props.context ? { context: props.context } : {}),
    };

    if (date && time) {
      const meetingLocal = moment.tz(`${date} ${time}`, "YYYY-MM-DD h:mm A", detectedTimezone);
      // Convert to UTC
      const meetingUTC = meetingLocal.utc();
      console.log("meetingUTC string format",meetingUTC.format());
      console.log("meetingUTC date format",meetingUTC.toDate());

      data = {
        proposedDate: date,
        proposedTime: time,
        meetingUTC: meetingUTC.toDate(),
        ...(props.eventId ? { eventId: props.eventId } : {}),
        ...(props.context ? { context: props.context } : {}),
      };
    }

    try {
      const res = await CommonAPI.PostCreateMeeting(props.responderId, data);
      console.log("Response from Post Create Meeting:",res);
      success("Meeting request sent");
      clearData();
      props.handleCloseModal();
      handleCloseMeetConfirmModal();
      handleCloseMeetTimeConfirmModal();
      handleCloseNoDateConfirmModal();
    } catch (err: any) {
      // Claude: show error modal — meeting limit exceeded or other backend error 10-04-2026
      Modal.error({
        title: "Meeting Request Failed",
        content: err?.response?.data?.message ?? "Failed to create meeting as subscription limits exceeded",
      });
    }
  };

  const checkMeetStatus = async () => {
    try {
      console.log("inside checkMeetStatus()");

      // If no date/time, ask user to confirm sending without date
      if (!date || !time) {
        handleOpenNoDateConfirmModal();
        return;
      }

    const selectedDate = new Date(date);
    selectedDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (selectedDate.getTime() === today.getTime()) {
      const [hours, minutes] = time.split(":");
      const selectedTime = new Date();
      selectedTime.setHours(parseInt(hours, 10), parseInt(minutes, 10), 0, 0);

      if (selectedTime.getTime() < new Date().getTime()) {
        error("Please enter correct value for time");
        return;
      }
    }

      const response = await CommonAPI.CheckMeetingAcceptAllowed(
        "NEWREQUEST",
        props.responderId,
        date,
        time
      );
      if (response) {
        // console.log("response..", response.data.data);
        const flag = response.data.data.isAllowed;
        if (flag) {
          console.log(
            "checkMeetStatus() : Meeting is allowed"
          );
          // allowed to accept meet
          handleSubmit();
        } else {
          console.log(
            "checkMeetStatus() : Meeting is not allowed"
          );

          // show confirmation and continue on yes
          handleOpenMeetTimeConfirmModal();
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleSubmit = async () => {
    // If no date/time, open no-date confirmation (should not reach here, but safety net)
    if (!date || !time) {
      handleOpenNoDateConfirmModal();
      return;
    }
    try {
      const propDate = new Date(date);
      const propTime = parseInt(time.split(":")[0]);

      if (propDate.getDay() !== 0 && propTime >= 9 && propTime <= 19) {
        handleConfirmCancelModal();
      } else {
        handleOpenMeetConfirmModal();
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <Box h={"100%"} w={"100%"}>
      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={meetTimeConfirm}
        onOk={handleCloseMeetTimeConfirmModal}
        onCancel={handleCloseMeetTimeConfirmModal}
      >
        <ConfirmationModal
          handleCloseModal={() => {
            handleCloseMeetConfirmModal();
            handleCloseMeetTimeConfirmModal();
          }}
          handleSubmit={() => {
            handleSubmit();
          }}
          title={"Another meeting exists"}
          message={
            "There is a confirmed meeting within 30 minutes of this meeting. Continue?"
          }
          confirmBtnText={"Yes, Confirm"}
          rejectButtonText={"No"}
        />
      </Modal>

      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={noDateConfirm}
        onOk={handleCloseNoDateConfirmModal}
        onCancel={handleCloseNoDateConfirmModal}
      >
        <ConfirmationModal
          handleCloseModal={handleCloseNoDateConfirmModal}
          handleSubmit={() => {
            handleConfirmCancelModal();
          }}
          title={"No date/time specified"}
          message={
            "You are setting a meeting without specifying a complete date-time. Continue?"
          }
          confirmBtnText={"Continue"}
          rejectButtonText={"Cancel"}
        />
      </Modal>

      <Modal
        closeIcon={null}
        footer={null}
        title={null}
        open={meetConfirm}
        onOk={handleCloseMeetConfirmModal}
        onCancel={handleCloseMeetConfirmModal}
      >
        <ConfirmationModal
          handleCloseModal={handleCloseMeetConfirmModal}
          handleSubmit={() => {
            handleConfirmCancelModal();
          }}
          title={"Please confirm action"}
          message={
            "Meeting time is set outside regular office hours (Weekdays: 9am to 7 pm).  Continue ?"
          }
          confirmBtnText={"Yes, Create"}
          rejectButtonText={"No"}
        />
      </Modal>
      <VStack
        position={"relative"}
        display={"flex"}
        justifyContent={"center"}
        alignItems={"center"}
        className={"create-meeting-modal"}
      >
        <Box position={"absolute"} right={0} top={0} py={3} cursor={"pointer"}>
          <MdClose
            size={20}
            onClick={() => {
              props.handleCloseModal();
            }}
          />
        </Box>
      </VStack>

      <Flex direction={"column"} justifyContent={"center"}>
        <Text
          fontSize={"md"}
          fontWeight={"regular"}
          mb={"16px"}
          textAlign={"center"}
        >
          Meeting request
        </Text>
        <Text
          fontSize={"sm"}
          mb={"11px"}
          fontWeight={"medium"}
          textAlign={"center"}
        >
          {props.company}
        </Text>
        <Text
          fontSize={"sm"}
          mb={"7px"}
          fontWeight={"medium"}
          textAlign={"center"}
        >
          {props.buyerCompanyName}
        </Text>
        <Text fontSize={"sm"} fontWeight={"light"} textAlign={"center"}>
          {props.designation}
        </Text>
        <FormControl mt={4}>
          {/* <FormLabel>Date</FormLabel> */}
          <Text fontSize={"xs"} fontWeight={"light"} fontStyle={"italic"}>
          *Appointments for telephonic/web meetings. Meetings are shown in your timezone. Date and time are optional.
          </Text>
          <InputGroup>
            <DatePicker
              value={date ? dayjs(date) : null}
              disabledDate={disabledDate}
              onChange={(time2, dateString) => {
                setDate(dateString);
              }}
              style={{ width: "100%", height: "50px" }}
              placeholder="Choose Date"
              inputReadOnly
              superNextIcon={null}
              superPrevIcon={null}
              popupClassName="custom-date-picker-meeting-popup"
            />
          </InputGroup>
        </FormControl>
        <FormControl mt={5}>
          {/* <FormLabel>Time</FormLabel> */}
          <input
            type="time"
            placeholder="Choose Time"
            style={{
              width: "100%",
              height: "50px",
              padding: "0 10px",
              border: "1px solid #E2E8F0",
              background: "white",
            }}
            onChange={(e) => {
              setTime(e.target.value);

            }}
            value={time}
          />
        
        </FormControl>
        
        <Flex alignItems={"center"} gap={3} mt={"25px"}>
          <Button
            onClick={() => {
              clearData();
              props.handleCloseModal();
            }}
            flex={1}
            width={"50%"}
            p={0}
            variant={"outline"}
            borderColor={"card.borderLight"}
            _hover={{ background: "secondary.light" }}
            borderRadius={"2px"}
          >
            <Text fontSize={"sm"} fontWeight={"regular"}>
              Cancel
            </Text>
          </Button>
          <Button
            width={"50%"}
            flex={1}
            onClick={checkMeetStatus}
            colorScheme="transparent"
            variant={"outline"}
            borderColor={"secondary.main"}
            _hover={{ background: "secondary.light" }}
            borderRadius={"2px"}
          >
            <Text fontSize={"sm"} fontWeight={"regular"}>
              Send
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Box>
  );
};

export default CreateMeetModal;
